module.exports = __webpack_public_path__ + "static/media/larnrod.76b3e4d6.JPG";